"use client";

import { usePopularProducts } from "@/modules/products/hooks/use-popular-products";
import { useCurrencyStore, useRegionStore } from "@/store/index";
import { ProductsGrid } from "@/modules/products/components/products-grid";
import { Skeleton } from "@/modules/common/components/skeleton";

export const PopularProducts = ({ countryCode }: { countryCode: string }) => {
  const { currencyCode } = useCurrencyStore();
  const { regionId } = useRegionStore();
  
  const { data, isLoading } = usePopularProducts({
    countryCode,
    regionId: regionId || undefined,
    currencyCode,
    queryParams: { limit: 8 },
  });

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6 xl:grid-cols-4">
        {[...Array(8)].map((_, i) => (
          <Skeleton key={i} className="h-60 w-full" />
        ))}
      </div>
    );
  }

  const products = data?.products || [];

  return <ProductsGrid products={products} />;
};
